import { render, staticRenderFns } from "./PermissaoEditar.vue?vue&type=template&id=46de4f96&"
import script from "./PermissaoEditar.vue?vue&type=script&lang=js&"
export * from "./PermissaoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports